module.exports = __webpack_public_path__ + "static/media/map-min.c2c86625.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/biznisnet2020/resources/map-min.png
// module id = 450
// module chunks = 0